/**
 * @module
 * @ignore
 * @internal
 */

import { settings } from "@lisn/globals/settings";
settings.autoWidgets = true;

export { settings } from "@lisn/globals/settings";
export * as watchers from "@lisn/watchers/index";
